import { UserPhoto } from "../hooks";
import { History } from "history";

export interface CanNavigate {
	history: History<unknown>;
}

export function getImageSrc(photo: UserPhoto | undefined) {
	if (photo) {
		// if (photo.base64String) {
		// 	return photo.base64String.startsWith(`data:image`)
		// 		? photo.base64String
		// 		: `data:image/png;base64,${photo.base64String}`;
		// }
		return photo.blobPath;
	}
	return undefined;
}

export function blobToBase64(blob: Blob): Promise<string> {
	return new Promise((resolve, _) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const result = reader.result as string;
			const imageData = result.split(";base64,")[1];
			// resolve(replace(result, /data:image\/(.)*;base64,/, ""));
			resolve(imageData);
		};
		reader.readAsDataURL(blob);
	});
}
